import Homework from '@/shared/publish/Homework';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/publish/Homework/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Homework />
}
